export default __webpack_public_path__ + "static/media/Level=6.f7ababea.svg";